
































































































































































































































































































import DkyTabs from './components/tabs.vue'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useHandler } from '@/hooks'
import { loadResourceData, Track } from '@/utils'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: {
      DkyTabs,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '首页',
        }))
      }

      loading = computed(() => this.apiData.loading)

      apiData = useApiPlus({
        resourceData: () =>
          loadResourceData({
            轮播: {
              id: '8aaa8fa484cbd04c0185066f500c01fe',
            },
            金刚区: {
              id: '8aaa8fa484cbd04c01850e8a5b9602a3',
              count: 12,
            },
            秒杀: {
              id: '8aaa8fa484cbd04c018506710eab0201',
              count: 1,
            },
            热销榜单: {
              id: '8aaa8fa484cbd04c01850672ceb00204',
              count: 3,
            },
            限时优惠: {
              id: '8aaa8fa484cbd04c01850673fdbb0207',
              count: 2,
            },
            特价商品: {
              id: '8aaa8fa484cbd04c01850675e744020a',
              count: 2,
            },
            在线课堂: {
              id: '8aaa8fa484cbd04c018506779723020d',
              count: 1,
            },
            推荐商品: {
              id: '8aaa8fa484cbd04c01850678d1ab0210',
              count: 1000,
            },
          }),
      })

      轮播数据 = computed(() => this.apiData.data.resourceData.轮播)

      金刚区数据 = computed(() => this.apiData.data.resourceData.金刚区)

      秒杀数据 = computed(() => this.apiData.data.resourceData.秒杀)

      热销榜单数据 = computed(() => this.apiData.data.resourceData.热销榜单)

      限时优惠数据 = computed(() => this.apiData.data.resourceData.限时优惠)

      特价商品数据 = computed(() => this.apiData.data.resourceData.特价商品)

      在线课堂数据 = computed(() => this.apiData.data.resourceData.在线课堂)

      推荐商品数据 = computed(() => this.apiData.data.resourceData.推荐商品)

      currentBannerIndex = ref(0)

      currentHotBannerIndex = ref(0)

      handleServiceClick = useHandler<
        '搜索' | '热销榜单' | '限时优惠' | '特价商品'
      >({
        搜索: () => {
          navigateTo('SearchEntry')
        },
        热销榜单: () => {
          navigateTo('DkyRxbd')
        },
        限时优惠: () => {
          navigateTo('DkyXsth')
        },
        特价商品: () => {
          navigateTo('DkyTjsp')
        },
      })

      handleLoadData = ({ pageNumber }: any) => {
        return pageNumber === 1 ? this.推荐商品数据.value : []
      }
    },
)
